import { Component, OnInit, Injector, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
const swal = require('sweetalert');
import * as ptLocale from 'date-fns/locale/pt';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from '../../../../util/loader.service';
import { Empresa } from '../../../../models/empresa/empresa';
import { EmpresaService } from '../empresa.service';
import { CustomValidators } from 'ng2-validation';
import { DatepickerOptions } from 'ng2-datepicker';
import { List } from 'lodash';

@Component({
  selector: 'app-auxiliar-empresa',
  templateUrl: './auxiliar-empresa.component.html',
  styleUrls: ['./auxiliar-empresa.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuxiliarEmpresaComponent implements OnInit {
  valForm: FormGroup;
  buttonType: any;
  public searchTyped = new BehaviorSubject('');
  public searchTypedCidades = new BehaviorSubject('');
  public searchTypedVendedor = new BehaviorSubject('');
  router: Router;
  id: any;
  empresa: Empresa;
  edicao = false;
  segmentos: Array<any>;

  public mask: Array<string | RegExp>;
  public maskIe: Array<string | RegExp>;
  public maskCep: Array<string | RegExp>;
  public maskData: Array<string | RegExp>;
  cortesia = false;
  parametroPagamentoCadastrar = false;
  options: DatepickerOptions = {
    locale: ptLocale,
    displayFormat: 'DD/MM/YYYY',
    barTitleIfEmpty: 'Clique para selecionar a data',
    placeholder: 'Clique para selecionar a data'
  };
  isChecked: boolean = false;
  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };



  constructor(public service: EmpresaService,
    public injector: Injector,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService) {

    // INTANCIA O OBJETO
    this.empresa = new Empresa();


    this.mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    this.maskCep = [/[1-9]/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    this.maskData = [/[1-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    this.maskIe = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/];

    // VALIDAÃ‡ÃƒO DO FORM
    this.valForm = fb.group({
      'empresaNome': [null, Validators.required],
      'empresaNomeFantasia': [null, null],
      'empresaDocumento': [null, Validators.required],
      //'empresaInicio': [null, CustomValidators.range([1, 30])],
      // 'empresaFim': [null, CustomValidators.range([1, 30])],
      'empresaEmail': [null, CustomValidators.email],
      'empresaEstado': [null, null],
      'empresaCidade': [null, null],
      'empresaBairro': [null, null],
      'empresaLogradouro': [null, null],
      'empresaCep': [null, null],
      'empresaNumero': [null, null],
      'empresaResponsavel': [null, Validators.required],
      'empresaTelefone': [null, null],
      'empresaSegmento': [null, null],
    });

    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id !== undefined && this.id != null) {
      this.loader.show('body');
      this.service.obterPorCodigo(this.id)
        .subscribe(itens => {
          this.loader.hide('body');
          this.empresa = itens;
        });
      this.edicao = true;
    } else {
      this.edicao = false;
    }
    this.carregarComboSegmento();
  }

  carregarComboSegmento() {
    this.service.listSegments('')
      .subscribe(itens => {
        this.segmentos = itens;
      });
  }

  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    // tslint:disable-next-line:forin
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.loader.show('body');
      this.service.atualizarEmpresa(this.empresa)
        .subscribe(result => {
          this.loader.hide('body');
          this.callbackSave(result);
        });
    }
  }

  callbackSave(result) {
    if (result == true) {
      swal('Atenção', 'Empresa salvo com sucesso.', 'success');
      this.valForm.reset();
      this.routerNavigate.navigate(['/fidel/empresa']);
    }
  }


  ngOnInit() {
  }
}

